import React from "react";
import { Link } from "react-router-dom";
import {
  Activity,
  Search,
  Book,
  Users,
  Radio,
  Shield,
  HelpCircle,
  MessageCircle,
} from "lucide-react";
import Navigation from "../components/Navigation";
import FooterSection from "../components/FooterSection";
import "./help.css";

export default function Help() {
  return (
    <div className="help-container">
      <Navigation />

      <main className="help-main">
        {/* Hero Section */}
        <section className="hero">
          <div className="hero-top">
            <div className="hero-badge">
              <HelpCircle className="icon" />
              <span>Help Center</span>
            </div>
            <h1 className="hero-title">
              How Can We <span className="highlight">Help You?</span>
            </h1>
            <p className="hero-subtitle">
              Find answers to common questions and learn how to use Medico.in
            </p>

            {/* Search */}
            <div className="search-container">
              <Search className="search-icon" />
              <input
                type="text"
                placeholder="Search for help articles..."
                className="search-input"
              />
            </div>
          </div>
        </section>

        {/* Quick Help Categories */}
        <section className="categories">
          <div className="card">
            <div className="card-icon users">
              <Users />
            </div>
            <h3 className="card-title">Getting Started</h3>
            <p className="card-desc">Setup your account and devices</p>
          </div>

          <div className="card">
            <div className="card-icon radio">
              <Radio />
            </div>
            <h3 className="card-title">Device Setup</h3>
            <p className="card-desc">Connect and configure sensors</p>
          </div>

          <div className="card">
            <div className="card-icon shield">
              <Shield />
            </div>
            <h3 className="card-title">Security</h3>
            <p className="card-desc">Privacy and data protection</p>
          </div>

          <div className="card">
            <div className="card-icon book">
              <Book />
            </div>
            <h3 className="card-title">Tutorials</h3>
            <p className="card-desc">Step-by-step guides</p>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="faq">
          <h2>Frequently Asked Questions</h2>

          <div className="faq-category">
            <h3>General Questions</h3>
            <div className="faq-item">
              <details>
                <summary>What is Medico.in?</summary>
                <p>
                  Medico.in is a comprehensive healthcare monitoring system that uses IoT sensors to track vital signs in real-time...
                </p>
              </details>
            </div>
            <div className="faq-item">
              <details>
                <summary>Who can use this system?</summary>
                <p>
                  The system is designed for both patients and healthcare providers...
                </p>
              </details>
            </div>
            <div className="faq-item">
              <details>
                <summary>How much does it cost?</summary>
                <p>
                  We offer flexible pricing plans starting from $29/month for individual patients...
                </p>
              </details>
            </div>
          </div>

          <div className="faq-category">
            <h3>Technical Questions</h3>
            <div className="faq-item">
              <details>
                <summary>What devices are compatible?</summary>
                <p>
                  We support medical-grade IoT sensors such as MAX30102, AD8232, and DS18B20...
                </p>
              </details>
            </div>
            <div className="faq-item">
              <details>
                <summary>How do I set up my sensors?</summary>
                <p>
                  Create an account, connect your microcontroller to WiFi, attach sensors, and start monitoring...
                </p>
              </details>
            </div>
          </div>

          <div className="faq-category">
            <h3>Security & Privacy</h3>
            <div className="faq-item">
              <details>
                <summary>Is my health data secure?</summary>
                <p>
                  Yes. We use AES-256 encryption and follow HIPAA and international data protection standards...
                </p>
              </details>
            </div>
            <div className="faq-item">
              <details>
                <summary>Who can access my health data?</summary>
                <p>
                  Only authorized healthcare providers and yourself can access your data...
                </p>
              </details>
            </div>
          </div>
        </section>

        {/* Contact Support */}
        <section className="contact-support">
          <div className="contact-card">
            <h3>Still Need Help?</h3>
            <p>Our support team is available 24/7 to assist you</p>
            <div className="contact-buttons">
              <Link to="/contact">
                <button className="btn">
                  <MessageCircle className="btn-icon" />
                  Contact Support
                </button>
              </Link>
              <Link to="/documentation">
                <button className="btn-outline">
                  <Book className="btn-icon" />
                  View Documentation
                </button>
              </Link>
            </div>
          </div>
        </section>
      </main>
      <FooterSection />
    </div>
  );
}
